import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=65959589&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65959589",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65959589')) {
      api.createRecord('65959589', component.options)
    } else {
      api.reload('65959589', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=65959589&scoped=true&", function () {
      api.rerender('65959589', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23Q6IZHfpWu1g/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports